module.exports = __webpack_public_path__ + "assets/fa4cadef6ebc9c86790689e2ebcb0cb0.png";